// extracted by mini-css-extract-plugin
export var equalColumn = "_f9-0";